import { useState } from 'react';
import { Button } from '@/shared/components';
import type { ReportMissingItemRequest } from '@/shared/api';

/** „Fehlt"-Meldung: Titel + Beschreibung (kein Schweregrad/Kosten). */
export function ReportMissingForm({
  onReport,
  isPending,
}: {
  onReport: (body: ReportMissingItemRequest) => void;
  isPending: boolean;
}) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const submit = () => {
    onReport({ title: title.trim(), description: description.trim() });
    setTitle('');
    setDescription('');
  };

  return (
    <div className="border-line/50 space-y-2 border-t pt-3 text-sm">
      <span className="text-ink-soft block text-xs uppercase tracking-wider">
        Fehlende Sache melden
      </span>
      <input
        type="text"
        placeholder="Was fehlt? (z.B. Handtücher)"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className="border-line w-full rounded border px-3 py-2"
      />
      <textarea
        placeholder="Beschreibung (z.B. Anzahl, Raum)"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        rows={2}
        className="border-line w-full rounded border px-3 py-2"
      />
      <div className="flex justify-end">
        <Button
          variant="brand"
          size="sm"
          loading={isPending}
          disabled={!title.trim() || !description.trim()}
          onClick={submit}
        >
          Fehlt melden
        </Button>
      </div>
    </div>
  );
}
